import FetchHelpers from 'utils/FetchHelpers';
import { apiRoutes } from 'routes';

export default {
  get(params) {
    const url = apiRoutes.authValidateTokenPath();

    return FetchHelpers.get(url, params);
  },
};



// WEBPACK FOOTER //
// ./src/repositories/auth/ValidateTokenRepository.js